export const Environment = {
  API_PATH: 'api/public',
  TITLE: 'Espace Adhérent',
  LOGO: 'assets/logo-menu-adherent.svg',
  LAYOUT_MENU: [
    {
      separator: true,
    },
    {
      label: 'Demande financement',
      items: [
        { label: 'Consulter les demandes', icon: 'pi pi-folder text-white', routerLink: 'demandes' },
        { label: 'Faire une demande', icon: 'pi pi-plus text-white', routerLink: '/financement' },
        {
          label: "Tester l'éligibilité",
          icon: 'pi pi-external-link text-white',
          url: 'https://docs.google.com/forms/d/e/1FAIpQLSdTGOKkt_nFYiZxjW9pvw24A5mg82EqBSaNhQ-HiEkchYHnjg/viewform',
        },
        {
          label: 'Financer un parcours diplômant',
          icon: 'pi pi-external-link text-white',
          url: 'https://docs.google.com/forms/d/e/1FAIpQLSdHI5KRmwtDnCxSQ8qwWvoMutFh_aBBJZ8gqLCOV6U-YO4iqg/viewform',
        },
        {
          label: 'Accéder au fonds relance',
          icon: 'pi pi-external-link text-white',
          url: 'https://docs.google.com/forms/d/e/1FAIpQLSd-ZKL1kc1gArnLj0PBuZQZWMt-jD9Xr2nSg3bgDTPkV-9omA/viewform',
        },
      ],
    },
    {
      label: 'Structure rattachées',
      items: [
        { label: 'Consulter les structures', icon: 'pi pi-building text-white', routerLink: 'structures' },
        { label: 'Ajouter une structure', icon: 'pi pi-plus text-white', routerLink: '/structure' },
        { label: 'Demande de rattachement', icon: 'pi pi-check text-white', routerLink: 'demande-de-rattachement' },
      ],
    },
    {
      label: 'Versements',
      items: [
        {
          label: 'Saisir un versement',
          icon: 'pi pi-calendar text-white',
          url: 'https://forms.gle/9JxGaX4Lhtfz4jzY7',
        },
        { label: 'Consulter les versements', routerLink: 'versements' },
        {
          label: 'Tuto versement',
          icon: 'pi pi-external-link text-white',
          url: 'https://www.fiaf.nc/boite-a-outils/bordereaux-de-versement',
        },
      ],
    },
    {
      label: 'Programmation du FIAF',
      items: [
        {
          label: 'Consulter les formations',
          icon: 'pi pi-book text-white',
          url: 'https://www.fiaf.nc/employeurs/programmation-du-fiaf',
        },
      ],
    },
    {
      label: 'Jeux du FIAF',
      items: [
        {
          label: 'Employeurs - Eléments',
          icon: 'pi pi-calendar text-white',
          url: 'https://element.fiaf.nc',
        },
      ],
    },
  ],
}
